// @Version: 1.0.1
export enum ICON {
   HOUSE = 'HOUSE',
   CIRCLE = 'CIRCLE',
   STAR = 'STAR',
   NUMBER = 'NUMBER'
}

export enum FC_RATING {
   RATINGBUTTON = "ratingbutton"
}

export interface IRateItem {
   icon: string,
   color: string
}

export enum MATERIAL {
   CIRCLE = 'circle',
   STAR = 'star',
   NUMBER = 'stop',
   HOUSE = 'store_mall_directory;storage;home;domain;location_city'
}